import { CapsuleTrend } from '@/components/Capsule/Capsule';
import { useDisplayNumber } from '@/hooks/useDisplayNumber';

type TrendWidgetProps = {
  trend: number | string;
  text?: string;
  className?: string;
};

export const TrendWidget = ({ trend, text, className, ...delegated }: TrendWidgetProps) => {
  const trendDisplay = `${useDisplayNumber(Number(trend ?? 0), { signDisplay: 'always' })} %`;

  const textDisplay = text ? `${trendDisplay} ${text}` : trendDisplay;

  const variant = parseInt(String(trend), 10) > 0 ? 'positive' : 'negative';

  return (
    <CapsuleTrend className={className} variant={variant} {...delegated}>
      {textDisplay}
    </CapsuleTrend>
  );
};
